import { pushDataLayerEvent } from '@/modules/services/gtm'

const reviewsMixin = {
  methods: {
    fetchReviews () {
      this.$store.dispatch('fetchReviews', {
        id: this.$route.params.id
      })
    },

    recordPaginationGtmEvent (pageNumber) {
      const paramName = vueSupport.isMobile ? 'click_value' : 'page_number'

      pushDataLayerEvent(
        'click_pagination_reviews', {
          params: {
            product_id: this.product.id,
            [paramName]: pageNumber
          }
        }
      )
    }
  }
}

export {
  reviewsMixin
}
